/*
================================================================
    Copyright © 2021, Cheers Interactive Pvt Ltd.  All rights reserved.
      File Description : Action buttons 
----------------------------------------------------------------
    Creation Details
    Date Created				: 04/June/2021
    Author						: Sandeep K. Sharma
================================================================
 */

import React from "react";
import { Link, useHistory } from "react-router-dom";
import { getProductVariant } from "../../../../utilities";
import { actionSuccess, actionError } from "../../../../middleware/actions/utilityAction";
import { useDispatch } from "react-redux";
import { showAlertBox } from "../../../../middleware/actions/alertBoxAction";
import { publishKia } from "../../../../middleware/services/kiaApi";
import { COMMON_ACCESS_ACTION } from "../../../../constants";

const ActionButtons = (props) => {
  const dispatch = useDispatch();
  const kiaId = props.kiaId || "";
  const history = useHistory();
  const productVariant = getProductVariant();
  const publish = async () => {
    const kiaId = props.kiaId;
    await publishKia(kiaId, { platform: productVariant })
      .then((res) => {
        if (res) {
          dispatch(actionSuccess("Kia has been published successfully"));
        } else {
          dispatch(actionError("Something went wrong"));
        }
      })
      .catch((err) => {
        let errMessage = "Kia cannot published : <br>";
        const errMessageArr = err?.data?.message ? err.data.message.split(",") : ["Something went wrong"];
        errMessage += errMessageArr
          .map((value, index) => {
            return ++index + "." + value + "<br>";
          })
          .join("");
        dispatch(actionError(errMessage));
      });
  };

  /* Common access */
  const accessActionSave = props?.interfaceActionAccess?.includes(COMMON_ACCESS_ACTION.SAVE);
  const accessActionPublish = props?.interfaceActionAccess?.includes(COMMON_ACCESS_ACTION.PUBLISH);

  return (
    <div className="form-submit-box"> 
          <div className="footer-layout">
            {props.selectedIndex > 0 || props.selectedIndex === undefined ? (
                  <button
                    type="button"
                    className="btn btn-outline-dark cy-btn"
                    onClick={() => {
                      (props.selectedIndex === undefined && props.setCurrentTab(4)) ||
                        (props.selectedIndex < 6 && props.setCurrentTab(props.selectedIndex - 1));
                    }}
                    // disabled={props.nextPath ? false : true}
                  >
                    Previous
                  </button>
            ) : null}
            {kiaId !== "" && props.selectedIndex > -1 && props.selectedIndex < 5 ? (
                  <button
                    type="button"
                    className="btn btn-outline-dark cy-btn"
                    onClick={() => {
                      props.selectedIndex < 5 && props.setCurrentTab(props.selectedIndex + 1);
                    }}
                    // disabled={props.nextPath ? false : true}
                  >
                    Next
                  </button>
            ) : null}
          </div>
          <div className="footer-layout">
            <Link to={"/kia" || history.location.pathname}>
              <button type="button" className="btn btn-outline-dark cy-btn">
                Cancel
              </button>
            </Link>
            {accessActionSave && props.handleSave && props.showSave ? (
              <button type="button" className="btn btn-primary cy-btn" id="dev-objective-save" onClick={props.handleSave}>
                Save
              </button>
            ) : null}
            {accessActionSave && props.handleSaveBrief && props.showSaveBrief ? (
              <button type="button" className="btn btn-primary cy-btn " id="dev-objective-save" onClick={props.handleSaveBrief}>
                Save
              </button>
            ) : null}

            {accessActionPublish && props.showPublished ? (
              <button
                type="button"
                className="btn btn-primary cy-btn"
                onClick={() => {
                  dispatch(
                    showAlertBox({
                      okCallback: async () => {
                        await publish();
                      },
                      content: "Are you sure you want to publish Key Impact Area?",
                      okText: "Publish",
                      cancelText: "Cancel",
                      title: "dialogAlertCss",
                    })
                  );
                }}
              >
                Publish
              </button>
            ) : null}
          </div> 
    </div>
  );
};

export default ActionButtons;
